import {
  parseAsString,
  parseAsArrayOf,
  useQueryStates,
  type HistoryOptions,
} from '@vrplatform/query-params';
import { useCallback, useMemo } from 'react';
import { useGenericTableStore } from '../../../stores';

export const useReservationTableFilter = () => {
  const [queryFilter, setQueryFilter] = useQueryStates({
    search: parseAsString,
    status: parseAsString,
    paidStatus: parseAsString,
    listingIds: parseAsArrayOf(parseAsString),
    listingCollectionId: parseAsString,
    listingStatus: parseAsString,
    connectionIds: parseAsArrayOf(parseAsString),
    bookingChannels: parseAsArrayOf(parseAsString),
    date: parseAsString,
    dateType: parseAsString,
  });

  const filterType = useGenericTableStore((s) => s.filterType);
  const stateFilter = useGenericTableStore((s) => s.filter);
  const setStateFilter = useGenericTableStore((s) => s.setFilter);

  const filter = useMemo(() => {
    if (filterType === 'query-params') {
      return queryFilter;
    }
    return stateFilter as typeof queryFilter;
  }, [filterType, stateFilter, queryFilter]);

  return {
    filter,
    setFilter: useCallback(
      (filter: Partial<typeof stateFilter>, updateType?: HistoryOptions) => {
        if (filterType === 'query-params') {
          setQueryFilter(filter, { history: updateType || 'push' });
        } else {
          setStateFilter(filter);
        }
      },
      [filterType, setQueryFilter, setStateFilter]
    ),
    reset: () => {
      const initial: Record<keyof typeof queryFilter, null> = {
        search: null,
        status: null,
        paidStatus: null,
        listingIds: null,
        listingCollectionId: null,
        listingStatus: null,
        connectionIds: null,
        bookingChannels: null,
        date: null,
        dateType: null,
      };

      setStateFilter(initial);
      setQueryFilter(null);
    },
  };
};
